import PartnerRolesAndLevelsEmpty from './Empty';
import PartnerRolesAndLevelsRolesOnly from './RolesOnly';
import PartnerRolesAndLevelsRoleAndLevel from './RoleAndLevel';

const constants = Object.freeze({
  PARTNER_ROLES_AND_LEVELS_DEFAULT: {},
  SELECTED_PARTNER_ROLE_CODE_DEFAULT: null
});

const propsDefaults = Object.freeze({
  partnerRolesAndLevels: constants.PARTNER_ROLES_AND_LEVELS_DEFAULT,
  selectedPartnerRoleCode: constants.SELECTED_PARTNER_ROLE_CODE_DEFAULT
});

export default function PartnerRolesAndLevels({
  partnerRolesAndLevels = propsDefaults.partnerRolesAndLevels,
  selectedPartnerRoleCode = propsDefaults.selectedPartnerRoleCode,
  className = ''
}) {
  const partnerRolesCount = !!partnerRolesAndLevels && 'object' === typeof partnerRolesAndLevels ? Object.keys(partnerRolesAndLevels).length : 0;
  return (
    <>
      {
        partnerRolesCount === 0 &&
        <PartnerRolesAndLevelsEmpty className={className}/>
      }
      {
        !selectedPartnerRoleCode &&
        (partnerRolesCount > 0) &&
        <PartnerRolesAndLevelsRolesOnly partnerRoleList={Object.keys(partnerRolesAndLevels)}
                                        className={className}/>
      }
      {
        !!selectedPartnerRoleCode &&
        (selectedPartnerRoleCode in partnerRolesAndLevels) &&
        <PartnerRolesAndLevelsRoleAndLevel partnerRole={selectedPartnerRoleCode}
                                           partnerLevel={partnerRolesAndLevels[selectedPartnerRoleCode]}
                                           className={className}/>
      }
      {
        !!selectedPartnerRoleCode &&
        !(selectedPartnerRoleCode in partnerRolesAndLevels) &&
        <PartnerRolesAndLevelsEmpty className={className}/>
      }
    </>

  );

}
